<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Aandeelhouders
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>In de specificatie 'Aandeelhouders' vermeld je een overzicht van de aandeelhouders.</p>
                <p>Vul de gegevens van de aandeelhouders in als je aangifte doet voor:</p>
                <ul style="list-style: disc;">
                    <li>een besloten vennootschap.</li>
                    <li>een naamloze vennootschap waarvan de aandelen niet op de beurs zijn genoteerd.</li>
                    <li>een naamloze vennootschap waarvan aandeelhouders met aandelenpakketten groter dan 5% bekend
                        zijn.
                    </li>
                </ul>
                <p>
                    Bij de vragen over het percentage aandelen en de nomimale waardes, bijvoorbeel de nominale waarde
                    gewone aandelen einde boekjaar, gaat het om de gegevens aan het einde van het boekjaar. Zijn de aandelen in het loop va het boekjaar verkocht, vul dan 0% en/of € 0 in.
                </p>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Wanneer aanmerkelijk belanghouder
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>In onder andere de volgende gevallen heeft de aandeelhouder een aanmerkelijk belang:</p>
                <ul class="bullet-list">
                    <li>hij bezit zelf of met zijn partner (opties op) minimaal 5% van het (geplaatste)
                        aandelenkapitaal.
                    </li>
                    <li>hij bezit zelf of met zijn partner minder dan 5% van het (geplaatste) aandelenkapitaal, maar een
                        van de naaste familieleden bezit wel 5% of meer.
                    </li>
                    <li>hij bezit winstbewijzen die betrekking hebben op minstens 5% van de winst of de
                        liquidatie-uitkering. Als de winstbewijzen door tijdsverloop minder dan 5% gaan
                        vertegenwoordigen, heeft hij geen aanmerkelijk belang meer.
                    </li>
                </ul>
                <p>Ook andere winstbewijzen, koopopties en vruchtgebruik op aandelen kunnen tot een aanmerkelijk belang
                    behoren.</p>
            </div>
        </div>
    </div>
</div>
